import { createElement, lazy } from 'react';

export const lazyLoadThenCreateComponent = (lazyLoad, componentName = 'default') =>
  createElement(lazy(() => lazyLoad().then((module) => ({ default: module[componentName] }))));
